/**
 * Blog Post Add-to-Cart Fix v2
 * Intercepts clicks on product "Add to cart" buttons in blog posts
 * and adds the product to cart via AJAX instead of navigating away.
 *
 * Fix: Added credentials: 'same-origin' to all fetch calls to maintain
 * session cookies on mobile browsers (Safari iOS strict cookie handling).
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Find all "Add to cart" buttons in shopblend sections
    const addToCartButtons = document.querySelectorAll('.sb-btn[href*="/products/"]');

    addToCartButtons.forEach(button => {
      button.addEventListener('click', handleAddToCart);
    });
  }

  async function handleAddToCart(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const originalText = button.textContent;

    // Get product URL from href
    const productUrl = button.getAttribute('href');
    if (!productUrl) return;

    try {
      // Disable button and show loading state
      button.disabled = true;
      button.textContent = 'Adding...';
      button.style.opacity = '0.6';
      button.style.pointerEvents = 'none';

      // Fetch product JSON to get variant ID
      const productHandle = productUrl.split('/products/')[1].split('?')[0];
      const productJson = await fetch(`/products/${productHandle}.js`, {
        credentials: 'same-origin'
      }).then(res => res.json());

      if (!productJson || !productJson.variants || productJson.variants.length === 0) {
        throw new Error('Product not found or no variants available');
      }

      // Get first available variant
      const availableVariant = productJson.variants.find(v => v.available);
      if (!availableVariant) {
        alert('Sorry, this product is currently out of stock.');
        return;
      }

      // Add to cart via Shopify AJAX Cart API
      const formData = {
        items: [{
          id: availableVariant.id,
          quantity: 1
        }]
      };

      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(formData)
      });

      if (!cartResponse.ok) {
        throw new Error('Failed to add product to cart');
      }

      // Success! Show feedback
      button.textContent = 'Added! ✓';
      button.style.opacity = '1';

      // Fetch updated cart to get cart count
      const cartJson = await fetch('/cart.js', {
        credentials: 'same-origin'
      }).then(res => res.json());

      // Trigger cart update events (for themes with cart drawer)
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartJson }
      }));
      document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:drawer:change', { bubbles: true }));

      // Try to open cart drawer using multiple methods
      const cartDrawer = document.querySelector('hdt-cart-drawer');
      if (cartDrawer) {
        // Try the open method
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: trigger a click on the cart icon
          const cartIcon = document.querySelector('[href="/cart"], [href*="cart"]');
          if (cartIcon) {
            cartIcon.click();
          }
        }
      }

      // Update cart count badges
      const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count');
      cartCountElements.forEach(el => {
        el.textContent = cartJson.item_count;
      });

      // Reset button after a delay
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.style.pointerEvents = '';
      }, 2000);

    } catch (error) {
      console.error('Add to cart error:', error);
      alert('Sorry, there was an error adding this product to your cart. Please try again.');

      // Reset button
      button.textContent = originalText;
      button.disabled = false;
      button.style.opacity = '1';
      button.style.pointerEvents = '';
    }
  }
})();
